import { fetchApi } from '@/lib/utils';

import type { ICompany } from '@enl/type-definitions';

export class CompanyService {
  static urls = {
    createCompany() {
      return `/v1/auth/company`;
    },
  };

  static async createCompany(payload: Omit<ICompany, 'branding'>) {
    const { data } = await fetchApi<{ data: ICompany }>(this.urls.createCompany(), {
      method: 'POST',
      data: payload,
    });
    return data;
  }
}
